import styled from "styled-components";
import Modal from "../../components/Modal";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import { Checkbox, Icon } from "@mui/material";
import Input, { InputTextArea } from "../../components/Input";
import CategorySelect from "../../components/CategorySelect";
import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { ConfirmPin } from "./ConfirmPin";
import Program, { EmptyPrograms, EmptyProgram } from "../../types/Program";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";

type UpdateModal = {
  announcement: any;
  setAnnouncement: any;
  fetchAnnouncement: () => void;
  isOpen?: boolean;
  isMobile?: boolean;
  setOpen: (x: boolean) => void;
  setMessageHeader: (x: string) => void;
  setMessageType: (x: "error" | "success" | "warning" | "info") => void;
  setIsMessageOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
};

export const UpdateModal = ({
  announcement,
  setAnnouncement,
  fetchAnnouncement,
  isOpen,
  setOpen,
  isMobile,
  setMessageHeader,
  setMessageType,
  setIsMessageOpen,
  setMessage,
}: UpdateModal): JSX.Element => {
  const HeaderBox = styled(FlexBox)`
    display: flex;
    align-items: center;
    padding: 12px 12px;
    background: #090d20;
    font-weight: bold;
    color: #ffffff;
  `;
  const PinCheckStyle = styled(FlexBox)`
    grid-column: span 2;
    align-items: center;
    display: flex;
    color: ${announcement.pinned ? "#ffffff" : "#d7d7d799"};
  `;

  const { user } = useContext(UserContext);
  const [confirmPin, setConfirmPin] = useState<boolean>(false);

  const universityContext = useContext(UniversityContext);
  const [selectedProgram, setSelectedProgram] = useState<Program>(
    announcement?.program_name
  );


  console.log('seleced prog', selectedProgram)
  const submitCreate = (e: any) => {
    e.preventDefault();
    const data = {
      ...announcement,
      announcement_id: announcement.id,
      email: user.email,
      university_code: user.university_code,
      program_name: selectedProgram?.label? selectedProgram?.value : selectedProgram,
    };
    if (isNaN(data.announcement_category)) {
      delete data.announcement_category;
    }
    axios
      .put("/announcement/update", data)
      .then((res) => {
        setOpen(false);
        fetchAnnouncement();
        setMessageType("success");
        setMessageHeader("Updated!");
        setMessage("Announcement has been updated!");
        setIsMessageOpen(true);
      })
      .catch((err) => {
        setMessageType("error");
        setMessageHeader("Failed!");
        setMessage(err?.response?.data?.error);
        setIsMessageOpen(true);
      });
  };

  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        content: {
          maxWidth: "800px",
          padding: 0,
          background: "#090d20",
          // border: "1px solid #2D416C",
          boxShadow: "0px 4px 16px rgba(0,0,0)",
          borderRadius: "8px",
        },
      }}
    >
      {confirmPin ? (
        <ConfirmPin
          isMobile={isMobile}
          HeaderBox={HeaderBox}
          setOpen={setConfirmPin}
          setAnnouncement={setAnnouncement}
          announcement={announcement}
        />
      ) : (
        <>
          <HeaderBox>
            <Icon
              sx={{
                // color: "#ffff86",
                mr: 1,
                textShadow: "0 1px 5px black",
                // fontSize:19
              }}
            >
              edit_note
            </Icon>
            <FlexGrow>Update Announcement</FlexGrow>
            <ClickableIcon
              name="times"
              onClick={() => setOpen(false)}
              style={{ color: "white" }}
            />
          </HeaderBox>

          <form
            onSubmit={(e) => submitCreate(e)}
            style={{
              padding: 30,
              display: "grid",
              gridTemplateColumns: "15% 85%",
              rowGap: 15,
            }}
          >
            Program
            <MinimalSelect
              styles={{
                container: (base) => ({
                  ...base,
                  // width: "100%",
                  minWidth: "100%",
                  marginRight: "8px",
                  zIndex: 9999,
                }),
                menu: (base) => ({
                  ...base,
                  // width: "max-content",
                  minWidth: "100%",
                }),
                menuPortal: (baseStyles, state) => ({
                  ...baseStyles,
                  zIndex: 999999999,
                }),
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  color: "white !important",
                  cursor: "default !important",
                }),
                input: (baseStyles, state) => ({
                  ...baseStyles,
                  color: "white !important",
                }),
              }}
              setClass={"custom-container"}
              required
              placeholder="Program"
              options={[
                { label: "ALL Programs", value: "" },
                ...universityContext.programs,
              ]}
              value={[
                { label: "ALL Programs", value: "" },
                ...universityContext.programs,
              ].find((v:any)=>v.value===selectedProgram)}
              onChange={(newValue: any) => {
                setSelectedProgram(newValue);
                setAnnouncement({
                  ...announcement,
                  program_name: newValue.value,
                });
              }}
            />
            Category
            <CategorySelect
              required
              selectedView={announcement.announcement_category}
              setSelectedView={(e: any) =>
                setAnnouncement({
                  ...announcement,
                  announcement_category: e.value,
                })
              }
            />
            Title
            <Input
              onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                setAnnouncement({
                  ...announcement,
                  [e.target.name]: e.target.value,
                })
              }
              maxLength={64}
              required
              isFullWidth
              id="title"
              name="title"
              placeholder="Title"
              value={announcement.title}
              style={{ color: "white" }}
            />
            Content
            <InputTextArea
              className="visible-scrollbar"
              onChange={(e: any) =>
                setAnnouncement({
                  ...announcement,
                  [e.target.name]: e.target.value,
                })
              }
              maxLength={2048}
              isFullWidth
              required
              id="content"
              name="content"
              placeholder="Content"
              value={announcement.content}
              style={{ color: "white" }}
            />
            URL
            <Input
              onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                setAnnouncement({
                  ...announcement,
                  [e.target.name]: e.target.value,
                })
              }
              maxLength={2048}
              // required
              isFullWidth
              id="url"
              name="url"
              placeholder="URL"
              value={announcement.url}
              style={{ color: "white" }}
            />
            <PinCheckStyle>
              <Checkbox
                checked={announcement.pinned}
                onClick={() =>
                  announcement.pinned
                    ? setAnnouncement({ ...announcement, pinned: false })
                    : setConfirmPin(true)
                }
                sx={{
                  color: "#d7d7d799",
                  "&.Mui-checked": {
                    color: "#ffffff",
                  },
                  marginLeft: -1.5,
                }}
              />
              <Icon
                sx={{
                  mr: 0.5,
                  textShadow: "0 1px 5px black",
                  transform: "rotate(45deg)",
                  fontSize: "15px",
                }}
              >
                push_pin
              </Icon>
              Pin Announcement
            </PinCheckStyle>
            <>&nbsp;</>
            <FlexBox justify="end" style={{ paddingTop: 10 }}>
              <Button
                type="button"
                style={{
                  width: isMobile ? "80px" : "150px",
                  height: "48px",
                }}
                isOutline
                status={Status.default}
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <FlexGrow style={{ flexGrow: "0" }}>
                <Button
                  type="submit"
                  style={{
                    width: isMobile ? "80px" : "150px",
                    height: "48px",
                    padding: "13px 12px",
                  }}
                  status={Status.button}
                >
                  Update
                </Button>
              </FlexGrow>
            </FlexBox>
          </form>
        </>
      )}
    </Modal>
  );
};
